module.exports = __webpack_public_path__ + "img/teams-small-folder.47842a84.svg";